import { render, staticRenderFns } from "./TabsSkeleton.vue?vue&type=template&id=781149b8&scoped=true"
import script from "./TabsSkeleton.vue?vue&type=script&lang=js"
export * from "./TabsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TabsSkeleton.vue?vue&type=style&index=0&id=781149b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781149b8",
  null
  
)

export default component.exports